/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/core/GetFileName.ts
 * @create:      2025-07-01 17:59:38.916
 * @modify:      2025-07-11 21:19:12.926
 * @version:     6.0.0
 * @times:       4
 * @lines:       57
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { Strings_Empty } from "../const/Strings";
import { GetBaseDir } from "./GetBaseDir";

/**
 * Extracts the file name from a given file path by removing the base directory.
 *
 * @param fileName - The full path or name of the file.
 * @returns The file name with the base directory removed, or the original string if no base directory is found.
 * 
 * @example
 * "c:/a/b.xyz" => "b.xyz"
 * "b.xyz" => "b.xyz"
 * 
 * @since 1.0.5
 * @version 2022-06-26
 */
export function GetFileName(fileName: string) {
    const base = GetBaseDir(fileName);
    if (base === fileName) {
        return fileName;
    }

    return fileName.replace(base, Strings_Empty);
}
